import { RouteMetadata } from './types';

export const toolsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/tools/toolboxes',
        section: 'tools',
        view: 'toolboxes',
        descriptionTemplate: 'User is viewing toolboxes',
        capabilities: [
            'View all toolboxes',
            'Create new toolboxes',
            'Edit toolbox configurations',
            'Add or remove tools from toolboxes',
            'Delete toolboxes',
        ],
        hints: [
            'Toolboxes are collections of related tools',
            'Toolboxes can be attached to agents or workflows',
            'Each toolbox contains multiple tools that work together',
            'Tools in a toolbox share a common purpose or domain',
        ],
    },
    {
        pattern: '/agents/:agentId/tools',
        section: 'tools',
        view: 'list',
        descriptionTemplate: 'User is viewing the tools list',
        capabilities: [
            'View all available tools',
            'Create new custom tools',
            'Edit tool definitions',
            'Test tools',
            'Delete tools',
            'View tool usage in workflows',
        ],
        hints: [
            'Tools are functions that agents can call',
            'Tools can make API requests, process data, or perform actions',
            'Each tool has a defined input schema and output format',
            'Tools can be used by LLM agents to take actions',
        ],
    },
];
